import React, { createContext, useContext, useState, useEffect } from "react";
import { NotificationResponse } from "../Api/Models/user.mode";

interface NotificationContextProps {
    notifications: NotificationResponse | null;
    fetchNotifications: (lastFetchTime: string | null) => Promise<void>;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<NotificationResponse | null>(null);
    const [lastFetchTime, setLastFetchTime] = useState<number | null>(null);

    const fetchNotifications = async (lastFetchTime: string | null) => {
        const now = Date.now();
/* TODO::TT ideiglenes */
        setNotifications(null);
        setLastFetchTime(now);

/*
        if (lastFetchTime && now - Number(lastFetchTime) < 60000) {
            console.log("Skipping fetch: Last fetch was less than 1 minute ago.");
            return;
        }

        try {
            const response = await userService.notifications(lastFetchTime);
            setNotifications(response);
            setLastFetchTime(now);
            console.log("Notifications:", response);
            console.log("Fetched notifications at:", new Date(now).toISOString());
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
*/
    };

    useEffect(() => {
        const interval = setInterval(() => {
            fetchNotifications(lastFetchTime ? lastFetchTime.toString() : null);
        }, 60000);

        return () => clearInterval(interval);
    }, [lastFetchTime]);

    return (
        <NotificationContext.Provider value={{ notifications, fetchNotifications }}>
            {children}
        </NotificationContext.Provider>
    );
};


export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error(
            "useNotifications must be used within a NotificationProvider"
        );
    }
    return context;
};
